"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBookingCalendar = void 0;
var _dateFns = require("date-fns");
var React = _interopRequireWildcard(require("react"));
var _helpers = require("../../../utils/helpers");
var _uiKit = require("@cian/ui-kit");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const minDate = new Date();
const useBookingCalendar = _ref => {
  let {
    isInitialLoading,
    isSelectedDatesInfoLoading,
    footerText,
    globalError,
    externalError,
    initialFrom,
    initialTo,
    daysAvailability,
    onApply: onApplyProp,
    onChange: onChangeProp,
    onReset: onResetProp,
    onClose: onCloseProp,
    onError,
    onShow
  } = _ref;
  /**
   * Доступность может динамически меняться в интерфейсе при выборе дат.
   * Так же есть случай с подсветкой дат только для выезда.
   * Поэтому мы пересчитываем доступность дней.
   * Рассчет происходит только на onChange и onReset для быстродействия.
   * Чтобы брать уже посчитанное значение в getDayStatus, который используется 2 раза для каждого дня.
   * */
  const initialProcessedDaysAvailability = React.useMemo(() => (0, _helpers.processDaysAvailability)(daysAvailability, initialFrom || undefined, initialTo || undefined), []);
  const [processedDaysAvailability, setProcessedDaysAvailability] = React.useState(initialProcessedDaysAvailability);
  const deviceType = (0, _uiKit.useDeviceType)();
  const isMobile = deviceType === 'phone';
  const maxDate = React.useMemo(() => (0, _dateFns.addDays)(minDate, processedDaysAvailability.length || 365), [processedDaysAvailability]);
  const [from, setFromDate] = React.useState(initialFrom || undefined);
  const [to, setToDate] = React.useState(initialTo || undefined);
  const [error, setError] = React.useState();
  const ranges = React.useMemo(() => [{
    key: 'selection',
    startDate: from,
    endDate: to
  }], [from, to]);
  const hasSelectedRange = !!from && !!to;
  const isResetButtonDisabled = !from && !to;
  const isSubmitButtonDisabled = !!error || !!externalError || isInitialLoading || isSelectedDatesInfoLoading || !hasSelectedRange;
  const submitButtonText = (0, _helpers.getButtonText)(!!from, hasSelectedRange);
  const checkDayDisabled = React.useCallback(date => (0, _helpers.getDayStatus)(processedDaysAvailability, date) === 0, [processedDaysAvailability, from, to]);

  // Отображает тултип над выбранной датой "от", если есть ошибки
  const getShowTooltip = React.useCallback(day => !isMobile && (!!error || !!externalError) && !!from && day.valueOf() === from?.valueOf(), [from, error, externalError, isMobile]);
  const onChange = React.useCallback(rangesByKey => {
    const {
      startDate,
      endDate
    } = rangesByKey.selection;
    if (!startDate || !endDate) {
      return;
    }
    const nextEndDate = endDate && startDate.valueOf() !== endDate.valueOf() ? endDate : undefined;
    setFromDate(startDate);
    setToDate(endDate);
    setProcessedDaysAvailability((0, _helpers.processDaysAvailability)(daysAvailability, startDate, nextEndDate));
    const [errorType, validationErrorMessage] = (0, _helpers.getValidationErrorMessage)({
      key: 'selection',
      startDate,
      endDate,
      daysAvailability
    });
    if (errorType && validationErrorMessage) {
      setError(validationErrorMessage);
      onError?.(errorType);
    } else {
      setError(undefined);
      onChangeProp(startDate, endDate);
    }
  }, [from, to, daysAvailability]);
  const onApply = React.useCallback(() => {
    if (!from || !to) {
      return;
    }
    onApplyProp(from, to);
  }, [from, to]);
  const onReset = React.useCallback(() => {
    setFromDate(undefined);
    setToDate(undefined);
    setProcessedDaysAvailability((0, _helpers.processDaysAvailability)(daysAvailability, undefined, undefined));
    onResetProp();
  }, [daysAvailability]);
  const onClose = React.useCallback(() => {
    onCloseProp();
  }, [from, to]);
  React.useEffect(() => {
    onShow?.();
  }, []);
  React.useEffect(() => {
    setProcessedDaysAvailability((0, _helpers.processDaysAvailability)(daysAvailability, from, to));
  }, [daysAvailability]);
  return React.useMemo(() => ({
    from,
    to,
    isMobile,
    isInitialLoading,
    isSelectedDatesInfoLoading,
    showGlobalError: globalError,
    isSubmitButtonDisabled,
    isResetButtonDisabled,
    footerText: error || externalError || footerText || '',
    submitButtonText,
    minDate,
    maxDate,
    onChange,
    onApply,
    onReset,
    onClose,
    hasSelectedRange,
    checkDayDisabled,
    ranges,
    error: error || externalError,
    getShowTooltip,
    processedDaysAvailability
  }), [from, to, isMobile, error, externalError, footerText, hasSelectedRange, checkDayDisabled, isSubmitButtonDisabled, isResetButtonDisabled, isInitialLoading, isSelectedDatesInfoLoading, maxDate, minDate, onChange, onApply, onReset, onClose, ranges, submitButtonText, getShowTooltip, processedDaysAvailability]);
};
exports.useBookingCalendar = useBookingCalendar;